import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import AuthApi from '../../Services/Authapi';
import parse from 'html-react-parser';
import './Documents.css';
import swal from 'sweetalert';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ls from "local-storage";
import Switch from '@material-ui/core/Switch';
import AuthCheckComponent from '../../Layouts/Token';
import "./Documentslist.css"
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

const USER_TEMPLATE_CACHE_KEY = 'user-templates-cache';

const getCachedTemplates = () => {
  try {
    const cachedValue = sessionStorage.getItem(USER_TEMPLATE_CACHE_KEY);
    if (!cachedValue) return [];

    const parsedValue = JSON.parse(cachedValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    console.error('Error reading cached templates:', error);
    return [];
  }
};

const normalizeTemplates = (response) => {
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response)) return response;
  return [];
};

const Latter = (props) => {
  const classes = props;
  const [data, setdata] = useState(() => getCachedTemplates());
  const [isLoading, setIsLoading] = useState(() => getCachedTemplates().length === 0);
  const [expandedItems, setExpandedItems] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push('/login');
    }
  });

  useEffect(() => {
    Templategetdata();
  }, []);

  const Templategetdata = async () => {
    const cachedTemplates = getCachedTemplates();
    const hasExistingData = cachedTemplates.length > 0 || data.length > 0;

    if (!hasExistingData) {
      setIsLoading(true);
    }

    try {
      let role = await AuthApi.Templategetdata();
      const normalizedTemplates = normalizeTemplates(role);
      setdata(normalizedTemplates);
      sessionStorage.setItem(USER_TEMPLATE_CACHE_KEY, JSON.stringify(normalizedTemplates));
    } catch (error) {
      console.error('Error fetching data:', error);
      if (!hasExistingData) {
        setdata([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const hardik = () => {
    props.history.push('/templates/add');
  };

  const toggleExpanded = (itemId) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };

  const handleCheckboxChange = async (id, status) => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode()
    });
    try {
      let statu = await AuthApi.Templategetstatu(id, status);
      swal.close();
      if (statu && statu.status === true) {
        swal("Success", "Template status update successfully!", "success");
        Templategetdata();
      } else {
        swal("Error", statu, "error");
      }
    } catch (error) {
      swal.close();
      swal("Error", "An error occurred, Please try again later!", "error");
    }
  };

  const handleEdit = (id) => {
    props.history.push(`/templates/edit/${id}`);
  };

  const handledelete = async (id) => {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        let currentPermission = await AuthApi.Templatedelete(id);
        if (currentPermission && currentPermission.status === true) {
          swal("Success", "Template delete successfully!", "success");
          Templategetdata();
        } else {
        }
      }
    });
  }

  const User = ls("user");

  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];

  const handleViewTemplate = (template) => {
    setSelectedTemplate(template);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <div className="holiday-breadcrumb-card">
                <Breadcrumb
                  {...props}
                  primaryPageName="User Template"
                  primaryPageLink="/templates"
                  isSecondaryPage={false}
                  secondaryPageName=""
                />
            </div>
            <Grid container className={classes.root} spacing={2} style={{ marginBottom: "75px" }}>
              <Grid item xs={12}>
                <Card className={`${classes.root} template-list-card`}>
                  <Grid item xs={12}>
                    <div className="template-list-header">
                      <CardContent className="template-list-header-content">
                        <Typography variant="h2" className="common-section-page-title" style={{ paddingTop: 0, paddingLeft: 0, paddingBottom: 0, marginBottom: "0" }}>Template All</Typography>
                      </CardContent>
                      <div className="template-list-header-action">
                        <Button
                          variant="contained"
                          onClick={hardik}
                          color="primary"
                          className="common-action-button common-add-button"
                          style={{ textTransform: 'capitalize' }}
                        >
                          Add
                        </Button>
                      </div>
                    </div>
                  </Grid>
                  <Grid container className={`${classes.root} template-list-grid`} spacing={3}>
                    {isLoading ? (
                      <Grid item xs={12} style={{ padding: "24px", minHeight: "150px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px" }}>
                        <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                          Loading templates...
                        </Typography>
                      </Grid>
                    ) : Array.isArray(data) && data.length > 0 ? data.map((item) => (
                      <Grid item xs={12} sm={6} md={4} key={item.id} className="template-grid-item">
                        <Card className={`${classes.card} template-item-card`}>
                          <CardContent className="template-item-card-content">
                            <Typography variant="h5" component="div" className="template-item-title">
                              {item.template_name}
                            </Typography>

                            {item.letters.length > 0 && (
                              <div className="template-item-view">
                                <Button
                                  className="common-view-button"
                                  style={{
                                    cursor: "pointer",
                                    textTransform: 'capitalize',
                                  }}
                                  onClick={() => handleViewTemplate(item)}
                                >
                                  View
                                </Button>
                              </div>
                            )}

                            <Grid
                              container
                              className={`${classes.root} template-item-actions`}
                              spacing={0}
                              justifyContent="center"
                              alignItems="center"
                            >
                              {userpermissions.includes("Template.Status") && (
                                <Grid item>
                                  <Tooltip title="Status">
                                    <Switch
                                      className="common-status-switch"
                                      checked={item.status === 1}
                                      onChange={() =>
                                        handleCheckboxChange(item.id, item.status === 1 ? 0 : 1)
                                      }
                                      color="primary"
                                    />
                                  </Tooltip>
                                </Grid>
                              )}

                              {userpermissions.includes("Template.Edit") && (
                                <Grid item>
                                  <Tooltip title="Template Edit">
                                    <IconButton
                                      variant="contained"
                                      color="primary"
                                      className="common-action-icon"
                                      onClick={() => handleEdit(item.id)}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-edit"
                                        colorName="primary"
                                        fontSize={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )}

                              {userpermissions.includes("Template.Delete") && (
                                <Grid item>
                                  <Tooltip title="Delete">
                                    <IconButton
                                      variant="contained"
                                      color="primary"
                                      className="common-action-icon"
                                      onClick={() => handledelete(item.id)}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-trash"
                                        colorName="primary"
                                        fontSize={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>

                        </Card>
                      </Grid>
                    )) : (
                      <Grid item xs={12} style={{ padding: "12px", minHeight: "150px", display: "flex", justifyContent: "center", alignItems: "flex-start", marginTop: "40px" }}>
                        <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                          No templates available
                        </Typography>
                      </Grid>

                    )}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
      <Dialog open={openDialog} onClose={handleCloseDialog} disableScrollLock={true} maxWidth="md" style={{ marginTop: "35px" }} >
        <DialogTitle>
          {selectedTemplate?.template_name}
        </DialogTitle>
        <DialogContent>
          {selectedTemplate && parse(selectedTemplate.letters)}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            color="primary"
            variant="contained"
            className="common-action-button"
            style={{ textTransform: 'capitalize' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Latter;
